import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FileText } from "lucide-react";

const TODAY = new Date().toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" });

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="max-w-3xl mx-auto px-6 pt-14 pb-20">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-xl bg-[hsl(var(--primary))]/10 grid place-items-center">
            <FileText className="w-6 h-6 text-[hsl(var(--primary))]" />
          </div>
          <div>
            <div className="overline text-[hsl(var(--primary))]">Legal · OFERTAS</div>
            <h1 className="font-display text-4xl sm:text-5xl tracking-tight">Términos de Servicio</h1>
          </div>
        </div>
        <p className="text-base text-muted-foreground mt-3">Última actualización: {TODAY}</p>

        <article className="prose-content mt-8 text-base leading-relaxed text-zinc-800 space-y-7">
          <Section title="1. Información del prestador del servicio">
            <p>
              La plataforma <strong>OFERTAS</strong> (en adelante "la Plataforma") es operada por <strong>Marketing de Inteligencia Artificial S. de R.L. de C.V.</strong> (en adelante "la Empresa"), con domicilio en <strong>Av. Las Américas 1545, pisos 20, 21 y 22, Col. Providencia, Guadalajara, Jalisco, México</strong>, teléfono <strong>33 1738 1875</strong> y correo de contacto <strong>hola@ofertas.mx</strong>.
            </p>
            <p>
              El representante legal y responsable del servicio es el <strong>Sr. Ricardo Zermeño Mejía</strong>.
            </p>
          </Section>

          <Section title="2. Aceptación de los Términos">
            <p>
              Al registrarte, usar o navegar por la Plataforma —ya sea como Comercio, Cliente, Promotor o Visitante— manifiestas haber leído, entendido y aceptado los presentes Términos de Servicio (los "Términos"), así como el Aviso de Privacidad publicado en la sección correspondiente. Si no estás de acuerdo, deberás abstenerte de usar la Plataforma.
            </p>
          </Section>

          <Section title="3. Objeto del servicio">
            <p>
              OFERTAS es un directorio digital local segmentado por código postal en el que los comercios afiliados publican anuncios y ofertas dirigidas a vecinos de su zona, y en el que los clientes pueden acumular puntos de lealtad y participar en una rifa mensual gratuita de electrodomésticos organizada por la Empresa.
            </p>
          </Section>

          <Section title="4. Tarifas y forma de pago para Comercios">
            <p>
              La cuota mensual de afiliación para Comercios es de <strong>$199 MXN (ciento noventa y nueve pesos mexicanos)</strong>, vigente al momento del registro. El pago se realiza <strong>exclusivamente mediante transferencia bancaria</strong> a la cuenta indicada dentro del panel del Comercio, a nombre del representante legal de la Empresa, <strong>Ricardo Zermeño Mejía</strong>.
            </p>
            <p>
              La activación de la suscripción se realiza una vez que la Empresa verifica el comprobante de pago, dentro de las siguientes 24 horas hábiles. La suscripción tiene vigencia de <strong>30 días</strong> y debe renovarse mensualmente. La Empresa puede modificar las tarifas dando aviso con al menos 30 días naturales de anticipación.
            </p>
          </Section>

          <Section title="5. Reglas para Comercios afiliados">
            <ul className="list-disc pl-6 space-y-2">
              <li>El Comercio se compromete a publicar únicamente información veraz, lícita y no engañosa sobre los productos o servicios que ofrece.</li>
              <li>El Comercio podrá generar hasta <strong>un (1) anuncio publicitario por mes calendario</strong> mediante la herramienta de Inteligencia Artificial integrada en la Plataforma.</li>
              <li>Queda prohibida la publicación de productos o servicios ilegales, ofensivos, discriminatorios, sexualmente explícitos, así como cualquier contenido que infrinja derechos de terceros.</li>
              <li>El Comercio es el único responsable de honrar las ofertas y promociones publicadas, así como de la entrega de premios de su programa de lealtad.</li>
              <li>La Empresa se reserva el derecho de retirar anuncios y suspender cuentas que incumplan estos Términos, sin reembolso del periodo en curso cuando el incumplimiento sea grave.</li>
            </ul>
          </Section>

          <Section title="6. Programa de Lealtad y Rifa mensual">
            <p>
              Cada compra realizada por un Cliente en un Comercio afiliado puede generar puntos en el programa de lealtad de ese Comercio (configurado por el propio Comercio) y, adicionalmente, <strong>un (1) boleto digital</strong> para la rifa mensual de electrodomésticos que organiza la Empresa.
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Los boletos se acumulan del día 1 al último día de cada mes calendario.</li>
              <li>El sorteo se realiza el último día del mes correspondiente entre todos los boletos activos.</li>
              <li>Tras el sorteo, los boletos del mes son archivados y los del mes siguiente comienzan a acumular.</li>
              <li>Los premios son anunciados por la Empresa al inicio de cada mes y publicados en la cuenta de cada Cliente.</li>
              <li>El ganador será contactado por la Empresa para coordinar la entrega del premio. La participación es gratuita y no requiere compra mínima.</li>
            </ul>
          </Section>

          <Section title="7. Programa de Promotores">
            <p>
              Los Promotores son personas físicas que refieren Comercios a la Plataforma y reciben una comisión recurrente de <strong>$100 MXN</strong> (o el monto que la Empresa defina) por cada mes que el Comercio referido pague su cuota. Las comisiones se calculan automáticamente al momento de aprobar el pago y se liquidan según los plazos publicados en el panel del Promotor. La Empresa podrá ofrecer adicionalmente bonificaciones por estructura de equipo conforme a las condiciones que dé a conocer por escrito.
            </p>
          </Section>

          <Section title="8. Cuentas de usuario y responsabilidad">
            <p>
              El usuario es responsable de la confidencialidad de sus credenciales de acceso (correo, teléfono, contraseña) y de toda actividad que se realice desde su cuenta. La Empresa no será responsable por accesos no autorizados causados por descuido del usuario.
            </p>
          </Section>

          <Section title="9. Propiedad intelectual">
            <p>
              La marca <strong>OFERTAS</strong>, el logotipo, la interfaz, los textos, ilustraciones e integraciones tecnológicas son propiedad de Marketing de Inteligencia Artificial S. de R.L. de C.V. o cuentan con la licencia respectiva. Los Comercios conservan los derechos sobre los textos e imágenes que publiquen y otorgan a la Empresa una licencia no exclusiva para mostrarlos en la Plataforma mientras la suscripción esté vigente.
            </p>
          </Section>

          <Section title="10. Limitación de responsabilidad">
            <p>
              La Empresa actúa exclusivamente como intermediario tecnológico entre Comercios y Clientes. La Empresa no es parte de las operaciones comerciales que se realicen entre las partes y no responde por la calidad, entrega, pago, garantía o cumplimiento de las promociones publicadas por los Comercios. La Plataforma se ofrece "tal cual" sin garantías implícitas de continuidad ininterrumpida del servicio.
            </p>
          </Section>

          <Section title="11. Cancelación y bajas">
            <p>
              El Comercio puede dejar de renovar su suscripción en cualquier momento. La Empresa puede suspender o terminar cuentas que incumplan estos Términos. Los datos personales serán tratados conforme al Aviso de Privacidad publicado en la Plataforma.
            </p>
          </Section>

          <Section title="12. Modificaciones">
            <p>
              La Empresa podrá actualizar estos Términos en cualquier momento. La versión vigente se publicará siempre en esta misma página, indicando la fecha de última actualización. El uso continuado de la Plataforma tras una modificación implicará la aceptación de los nuevos Términos.
            </p>
          </Section>

          <Section title="13. Legislación aplicable y jurisdicción">
            <p>
              Estos Términos se rigen por las leyes federales de los Estados Unidos Mexicanos. Para cualquier controversia, las partes se someten expresamente a la jurisdicción de los tribunales competentes en la ciudad de <strong>Guadalajara, Jalisco</strong>, renunciando a cualquier otro fuero que pudiera corresponderles.
            </p>
          </Section>

          <Section title="14. Contacto">
            <p>
              Para cualquier duda o aclaración relacionada con estos Términos, puedes escribir a <strong>hola@ofertas.mx</strong>, llamar al <strong>33 1738 1875</strong> o acudir al domicilio de la Empresa.
            </p>
          </Section>

          <div className="mt-10 bg-[#F5F3FF] border border-[#DDD6FE] rounded-2xl p-5 text-sm">
            <strong className="text-[#5B21B6]">Representante legal:</strong> Sr. Ricardo Zermeño Mejía<br />
            <strong className="text-[#5B21B6]">Razón social:</strong> Marketing de Inteligencia Artificial S. de R.L. de C.V.<br />
            <strong className="text-[#5B21B6]">Domicilio:</strong> Av. Las Américas 1545, pisos 20, 21 y 22, Col. Providencia, Guadalajara, Jalisco, México.<br />
            <strong className="text-[#5B21B6]">Teléfono:</strong> 33 1738 1875
          </div>
        </article>
      </section>
      <Footer />
    </div>
  );
}

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-display text-2xl tracking-tight text-zinc-900">{title}</h2>
    <div className="mt-3 space-y-3 text-zinc-700">{children}</div>
  </section>
);
